import React from 'react';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { Check } from 'lucide-react';
export const TrainingPackages = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('training-proposal-form');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-gray-50" data-id="element-1213">
      <div className="container mx-auto px-4" data-id="element-1214">
        <div className="text-center mb-16 scroll-animate" data-id="element-1215">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1216">
            Training Packages
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1217">
            Choose the right level of engagement for your team's capacity
            building needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-1218">
          {/* Package 1 */}
          <Card className="scroll-animate p-8 border-2 border-gray-200 hover:border-gray-300 transition-colors h-full flex flex-col" data-id="element-1219">
            <div className="mb-6" data-id="element-1220">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1221">
                Starter Workshop
              </h3>
              <p className="text-gray-500 font-medium" data-id="element-1222">For small teams.</p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1223">
              <div className="flex items-start" data-id="element-1224">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1225" />
                <span className="text-gray-700" data-id="element-1226">
                  Half-day or 1-day workshop
                </span>
              </div>
              <div className="flex items-start" data-id="element-1227">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1228" />
                <span className="text-gray-700" data-id="element-1229">
                  Team size: up to 20 people
                </span>
              </div>
              <div className="flex items-start" data-id="element-1230">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1231" />
                <span className="text-gray-700" data-id="element-1232">
                  Interactive training session
                </span>
              </div>
              <div className="flex items-start" data-id="element-1233">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1234" />
                <span className="text-gray-700" data-id="element-1235">
                  Digital learning materials
                </span>
              </div>
            </div>

            <Button variant="outline" className="w-full py-3" onClick={scrollToForm} data-id="element-1236">
              Request Proposal
            </Button>
          </Card>

          {/* Package 2 - Highlighted */}
          <Card className="scroll-animate p-8 border-2 border-primary shadow-xl relative transform lg:-translate-y-4 h-full flex flex-col bg-white z-10" data-id="element-1237">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1238">
              <span className="bg-primary text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-1239">
                Most Popular
              </span>
            </div>

            <div className="mb-6 mt-2" data-id="element-1240">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1241">
                Team Transformation
              </h3>
              <p className="text-primary font-medium" data-id="element-1242">
                For organizations building capacity.
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1243">
              <div className="flex items-start" data-id="element-1244">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1245" />
                <span className="text-gray-700 font-medium" data-id="element-1246">
                  2–3 day training program
                </span>
              </div>
              <div className="flex items-start" data-id="element-1247">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1248" />
                <span className="text-gray-700 font-medium" data-id="element-1249">
                  Customized curriculum
                </span>
              </div>
              <div className="flex items-start" data-id="element-1250">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1251" />
                <span className="text-gray-700 font-medium" data-id="element-1252">
                  Practical exercises & labs
                </span>
              </div>
              <div className="flex items-start" data-id="element-1253">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1254" />
                <span className="text-gray-700 font-medium" data-id="element-1255">
                  Post-training resources
                </span>
              </div>
              <div className="flex items-start" data-id="element-1256">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1257" />
                <span className="text-gray-700 font-medium" data-id="element-1258">
                  Impact assessment report
                </span>
              </div>
            </div>

            <Button className="w-full py-4 text-lg shadow-md hover:shadow-lg" onClick={scrollToForm} data-id="element-1259">
              Request Proposal
            </Button>
          </Card>

          {/* Package 3 */}
          <Card className="scroll-animate p-8 border-2 border-gray-200 hover:border-gray-300 transition-colors h-full flex flex-col" data-id="element-1260">
            <div className="mb-6" data-id="element-1261">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1262">
                Institutional Partnership
              </h3>
              <p className="text-gray-500 font-medium" data-id="element-1263">
                For schools and organizations.
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1264">
              <div className="flex items-start" data-id="element-1265">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1266" />
                <span className="text-gray-700" data-id="element-1267">
                  Long-term learning partnership
                </span>
              </div>
              <div className="flex items-start" data-id="element-1268">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1269" />
                <span className="text-gray-700" data-id="element-1270">
                  Multiple training sessions per year
                </span>
              </div>
              <div className="flex items-start" data-id="element-1271">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1272" />
                <span className="text-gray-700" data-id="element-1273">Program design support</span>
              </div>
              <div className="flex items-start" data-id="element-1274">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1275" />
                <span className="text-gray-700" data-id="element-1276">
                  Community access to The Networking Salon network
                </span>
              </div>
            </div>

            <Button variant="outline" className="w-full py-3" onClick={scrollToForm} data-id="element-1277">
              Request Proposal
            </Button>
          </Card>
        </div>
      </div>
    </section>;
};